import { DeleteAudienceEntity } from "../../domain/entities/delete-audience.entity";

export class DeleteAudienceModel extends DeleteAudienceEntity {
    override toJson(): Map<string, any> {
        let json: Map<string, any> = new Map();
        json.set('id', this.id);
        return json;
    }
}